import React from 'react';
import PropTypes from 'prop-types';
import {
  FileUpload, WebRequest, Snackbar, Badge,
} from '@cgn/framework-ui-components/v1';
import { Button } from '@cgn/framework-ui-components/v2';
import { AttachIcon, CloseIcon } from '@cgn/framework-ui-components/googleOutlinedIcons';
import { UPLOAD_FILE_ERROR, UPLOADING_FILE } from '../messages';
import InfoModaleQuesito from '../InfoModaleQuesito';

/**
*/
const AllegatiQuestionario = ({
  allegati, onAddAllegato, onRemoveAllegato, onChageUploading, infoModaleQuesito,
}) => (
  <>
    <div className="helpdesk-frontend-questionario__seleziona-allegati">
      <FileUpload
        url="/NuovaPratica/CreaAllegatoTemporaneo"
        className="helpdesk-frontend-questionario__seleziona-allegati"
        max={8}
        // uso test. se usavo il default non riuscio a fare il mock nei test
        uploader={WebRequest}
        onChange={() => {
          onChageUploading(true);
          Snackbar.creaOperazioneMassiva({
            type: Snackbar.Types.MASSIVA, id: 1, message: UPLOADING_FILE, selezionati: 1,
          });
        }}
        onFileUploaded={(res, file) => {
          onChageUploading(false);
          if (res.Success) {
            Snackbar.clear();
            onAddAllegato({ nome: file.name, id: res.IdAllegato });
            setTimeout(() => Snackbar.clear(), 200);
          } else {
            setTimeout(() => {
              Snackbar.clear();
              Snackbar.show({ type: Snackbar.Types.ERROR, message: UPLOAD_FILE_ERROR });
            }, 200);
          }
        }}
        onCatch={() => {
          onChageUploading(false);
          onAddAllegato({ nome: 'Prova', id: '1' });
          setTimeout(() => {
            Snackbar.clear();
            Snackbar.show({ type: Snackbar.Types.ERROR, message: UPLOAD_FILE_ERROR });
          }, 200);
        }}
      >
        <Button>
          <AttachIcon />
          Allega documentazione a supporto
        </Button>
      </FileUpload>
      <InfoModaleQuesito infoModaleQuesito={infoModaleQuesito} />
    </div>
    <div className="helpdesk-frontend-questionario__lista-allegati">
      {allegati.map((allegato) => (
        <Badge
          key={allegato.id}
          className="helpdesk-frontend-questionario__allegato-item"
          onClick={() => { onRemoveAllegato(allegato); }}
        >
          {allegato.nome}
          <CloseIcon />
        </Badge>
      ))}
    </div>
  </>
);

AllegatiQuestionario.propTypes = {
  onChageUploading: PropTypes.func.isRequired,
  infoModaleQuesito: PropTypes.shape({
    type: PropTypes.string.isRequired,
    htmlMessage: PropTypes.string.isRequired,
  }),
  allegati: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    nome: PropTypes.string.isRequired,
  })),
  onAddAllegato: PropTypes.func.isRequired,
  onRemoveAllegato: PropTypes.func.isRequired,
};

AllegatiQuestionario.defaultProps = {
  infoModaleQuesito: undefined,
  allegati: [],
};

export default AllegatiQuestionario;
